<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb :lastItemName="getOffers.title" />
      </b-col>
      <!-- Content Right -->
    </b-row>
    <div>

      <b-card

          img-alt="Profile Cover Photo"
          img-top
          class="card-profile"
      >
        <div class="profile-image-wrapper">
          <div class="profile-image p-0">
            <b-avatar
                size="114"
                variant="light"
                :src="
                    getOffers.seller.avatar.path
                      ? $http.defaults.fileUrl + getOffers.seller.avatar.path
                      : ''
                  "
            />
          </div>
        </div>
        <h3> {{getOffers.seller.full_name}}</h3>
        <h6 class="text-muted">
          {{getOffers.service_name}}
        </h6>
        <div>
          <strong>
            لیدر :
          </strong>
          {{getOffers.service_full_name}}
        </div>
        <hr class="mb-2">

        <!-- follower projects rank -->
        <div>
          <div v-for="(rule,r) in getOffers.rules" :key="r">
            <div class="d-flex my-1">
              <div>از </div>
              <div class="mx-2">
                <b-badge variant="dark">
                  {{rule.min}} نفر
                </b-badge>
              </div>
              <div> تا </div>
              <div class="mx-2">
                <b-badge variant="dark">
                  {{rule.max}} نفر
                </b-badge>
              </div>
              <div>
                <b-badge variant="success">
                  {{rule.percent}}
                  درصد
                </b-badge>
              </div>
            </div>
          </div>

          <h5>مشاهده کد تخفیف تولید شده</h5>
          <b-table-simple responsive>
            <b-thead>
              <b-tr>
                <b-th>ردیف</b-th>
                <b-th>کد تخفیف</b-th>
                <b-th>تاریخ ایجاد</b-th>
                <b-th>وضعیت</b-th>

              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(discount,i) in getOffers.codes" :key="discount.id">
                <b-td>{{ i+1 }}</b-td>
                <b-td>{{ discount.salt+discount.code }}</b-td>
                <b-td>
                  {{
                    new Date(discount.created_at).toLocaleString("fa-IR", {
                      timeZone: "Iran",
                    })
                  }}
                </b-td>
                <b-td>
                  <span v-if="discount.is_used">
                        <b-badge variant="success">
                        استفاده شده
                      </b-badge>
                  </span>
                  <span v-else>
                        <b-badge variant="danger">
                        استفاده نشده
                      </b-badge>
                  </span>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>

        </div>
        <!--/ follower projects rank -->
      </b-card>
    </div>

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormCheckbox,
  BTableSimple,
  BThead,
  BTbody,
  BFormSelect,
  BTr,
  BTh,
  BTd,
  BFormCheckboxGroup,
  BFormSpinbutton,
  BTime,
  BInputGroup, BBadge,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import ErrorMessage from "@/components/ErrorMessage.vue";
import FilePicker from "@/components/FilePicker.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    BBadge,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    BFormSelect,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    ErrorMessage,
    BFormCheckbox,
    FilePicker,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BFormCheckboxGroup,
    BFormSpinbutton,
    BTime,
    datePicker: VuePersianDatetimePicker,
    BInputGroup,
  },
  data() {
    return {

      iconImageurl: "",
      errorMessage: {},
      perPage: 10,
      page: 1,
      paginationData: null,

      users: [],
      experiences: [],

      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",


      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      buildingsCancelToken: undefined,


      discountInput: {
        id: "",
        title: "",
        seller_id: "",
        serviceable_table: "experience",
        serviceable_id: "",
        salt: "",
        count:"",
        rules:  [],
        desc: "",
        image : null,
        status: "",

      },
      discountOffs:[],

      getOffers:null,

      editMode: false,
      formModal: false,
      submitLoading: false,
      discounts: 0,
      removeDiscountBtnIsClicked: false,
      clickOnDiscountSpinBtn:false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getShowDiscount();
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      // this.getTickets();
    },
    perPage(value) {
      this.page = 1;
      //  this.getTickets();
    },
    page(value) {
      // this.getTickets();
    },



  },
  methods: {
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },




    async getShowDiscount() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        search: this.searchInput,
        per_page: this.perPage,
        page: this.page,
        sort_by: this.sortBy,
        sort_dir: this.sortDir,
        paginate:true
      };

      const requestData = {
        method: "get",
        url: "/admin/discounts/"+this.$route.params.id,
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.getOffers = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },

    formatnumber(newValue) {
      const result = newValue
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return result;
    },


  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>